import { Box } from '@mui/material'
import React, { lazy } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SectionTitle } from './LatestProducts'
import ins1 from '../assets/images/instagram/ins1.webp'
import ins2 from '../assets/images/instagram/ins2.webp'
import ins3 from '../assets/images/instagram/ins3.jpg'
import ins4 from '../assets/images/instagram/ins4.webp'
import ins5 from '../assets/images/instagram/ins5.webp'
import ins6 from '../assets/images/instagram/ins6.webp'
import ins7 from '../assets/images/instagram/ins7.jpg'
import ins8 from '../assets/images/instagram/ins8.webp'
import ins9 from '../assets/images/instagram/ins9.webp'
import ins11 from '../assets/images/instagram/ins11.webp'
import loading from '../assets/images/imageLoading.gif'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Navigation,Lazy,Autoplay, Keyboard } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/lazy';
export default function FollowInstagram() {
    const images = [ins1,ins2,ins3,ins4,ins5,ins6,ins7,ins8,ins9,ins11]
   return (
    <Box sx={{ my:{lg:8,md:6,sm:4,xs:4},zIndex:10,overflow:'hidden',background:'white'}}>
       <SectionTitle>@ FOLLOW US ON INSTAGRAM</SectionTitle>
       <Swiper
        modules={[Navigation,Lazy,Autoplay, Keyboard]}
        lazy={true}
        autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          keyboard={{
            enabled: true,
          }}
        //   loop={true}
          breakpoints={{
            320: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            480: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            640: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
          grabCursor={true}
        spaceBetween={20}
        slidesPerView={6}
        navigation
        scrollbar={{ draggable: true }}
    >
        {images.map((image,index)=><SwiperSlide key={index}><LazyLoadImage placeholderSrc={loading} src={image}  width="100%" height="100%" styled={{ objectFit:'cover' }} alt="ins1"/></SwiperSlide>)}
    </Swiper>
    </Box>
  )
}
